import axios from 'axios'
import { atom } from 'jotai'

import { settings } from '../@types/settings'

const getSettingsJson = new Promise<settings>(resolve => {
  try {
    axios.get('./spec/settings.json').then(res => {
      resolve(res.data)
    })
  } catch (err) {
    resolve({
      version: '1.0.0',
      title: '',
      dataFile: '',
      displayYear: 2023, // 一応デフォルトは2023にしておく
      saturday: true,
      grade: [],
      selector: [],
    })
  }
})

export const settingsState = atom(getSettingsJson)
